import { UserSimpleInfo } from 'app/core/models'

export class RoleWithUsersSimpleInfo {    
     constructor(public role: string, 
                public isChecked: boolean, 
                public users: UserSimpleInfo[] = []){ }
}